/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const USER_MODULE_COMPONENTS = {
  USER_MODULE_NAME: 'User Module',
  USER_SERVICE: 'UserService',
};

export const CACHE_MODULE_COMPONENTS = {
  CACHE_MODULE_NAME: 'Cache Module',
  CACHE_MANAGER_SERVICE: 'CacheManagerService',
};

export const PAYMENT_CONSTANTS = {
  PAYMENT_METHOD_NAME: 'storedPayments',
};

export const HEADER_CONSTANTS = {
  BILLING_TYPE: 'billingtype',
  DEALER_CODE: 'dealerCode',
};

export const SELECT_REP_ROLE = {
  IMG_PATH: 'assets/images/header_logo.png',
};
export const USER_SERVICE_CONSTANTS = {
  P10M_CUSTOMER: '10million',
  TESTDRIVE: 'testdrive',
};
export const UMTS_CONSTANTS = {
  SUSPENDED: 'SUSPENDED',
  RESTORE: 'RESTORE',
};

export const DATA_ONLY_PLANS = {
  PLAN_NAME: 'Mobile Internet Network Access',
}